// ============================================================================
// Dedrone integration API client.
//
// Phase 10: multi-instance. Each integration is its own row; tenants can
// connect any number of DroneTracker servers. Tokens are write-only — the
// API never returns them, so the UI only ever has `hasApiToken: boolean`.
// The webhook URL is computed server-side and included on every read so the
// operator can copy-paste it into DroneTracker per server.
// ============================================================================
import { api } from './api';

export interface DedroneIntegration {
  id: string;
  label: string;
  baseUrl: string;
  hasApiToken: boolean;
  webhookId: string;
  webhookUrl: string;
  pollIntervalSeconds: number;
  enabled: boolean;
  lastPulledAt: string | null;
  lastWebhookAt: string | null;
  lastError: string | null;
  lastErrorAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface DedroneIntegrationInput {
  label?: string;
  baseUrl: string;
  apiToken?: string;
  pollIntervalSeconds?: number;
  enabled?: boolean;
}

export const dedroneApi = {
  list: async (): Promise<DedroneIntegration[]> => {
    const res = await api.get('/integrations/dedrone');
    return (res.data?.data ?? []) as DedroneIntegration[];
  },

  get: async (id: string): Promise<DedroneIntegration> => {
    const res = await api.get(`/integrations/dedrone/${id}`);
    return res.data.data as DedroneIntegration;
  },

  create: async (input: DedroneIntegrationInput): Promise<DedroneIntegration> => {
    const res = await api.post('/integrations/dedrone', input);
    return res.data.data as DedroneIntegration;
  },

  update: async (id: string, input: DedroneIntegrationInput): Promise<DedroneIntegration> => {
    const res = await api.patch(`/integrations/dedrone/${id}`, input);
    return res.data.data as DedroneIntegration;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/integrations/dedrone/${id}`);
  },
};
